import { useEffect, useRef } from "react";

const Starfield = () => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    const g = c.getContext("2d");
    let w, h, raf;
    let stars = [];
    const resize = () => {
      w = c.width = window.innerWidth;
      h = c.height = window.innerHeight;
      stars = Array.from({ length: Math.min(w < 768 ? 90 : 180, Math.floor((w * h) / 9000)) }, () => ({
        x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.2 + 0.2, p: Math.random() * 6.28, s: 0.5 + Math.random() * 1.5,
      }));
    };
    resize();
    window.addEventListener("resize", resize);
    let lastT = 0;
    const draw = (t) => {
      raf = requestAnimationFrame(draw);
      if (t - lastT < 66) return;
      lastT = t;
      g.clearRect(0, 0, w, h);
      for (const s of stars) {
        const a = 0.35 + 0.65 * Math.abs(Math.sin(t / 1000 * s.s + s.p));
        g.fillStyle = `rgba(226,232,240,${a * 0.8})`;
        g.beginPath(); g.arc(s.x, s.y, s.r, 0, 6.28); g.fill();
      }
    };
    raf = requestAnimationFrame(draw);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); };
  }, []);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full" />;
};

export const AuroraBackground = ({ intense = false }) => (
  <div className="fixed inset-0 -z-10 overflow-hidden bg-[#030712]" aria-hidden>
    <Starfield />
    <div className={`aurora-layer ${intense ? "opacity-90" : "opacity-50"}`}>
      <span className="aurora-band band-1" />
      <span className="aurora-band band-2" />
      <span className="aurora-band band-3" />
      <span className="aurora-band band-4" />
    </div>
    <div className="hud-grid" />
    <div className="noise" />
  </div>
);
